export const ROLES = {
  ADMINISTRATOR: 'administrador',
  SUPERVISOR: 'supervisor',
  EMPLOYEE: 'colaborador',
  SYSTEM_ADMIN: 'system_admin'
}
